import {PreferredPaymentMethodEnum} from '@/services/api-clients';

export function driverPreferredPaymentMethodIconFilter(type: PreferredPaymentMethodEnum): string {
  switch (type) {
    case PreferredPaymentMethodEnum.Transfer: return 'mdi-bank-transfer-in';
    case PreferredPaymentMethodEnum.Cash: return 'mdi-cash';
    case PreferredPaymentMethodEnum.Blik: return 'blik.svg';
    case PreferredPaymentMethodEnum.IngCard: return 'ing.svg';
    case PreferredPaymentMethodEnum.Revolut: return 'revolut.svg';
  }
}
